import { useStore } from '../state/ui-store';

export const displayParticles = () => {
  const { visibilityFuncs } = useStore.getState();
  visibilityFuncs.fluid(1);
};
